<!--
 * @Author: 窦云飞 df1987131@yeah.net
 * @Date: 2023-07-10 10:44:24
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @LastEditTime: 2024-01-26 16:01:47
 * @FilePath: /epec-bidding/Users/douyunfei/Documents/epec-ea/src/modules/projectA/pages/ES/ESapply/component/evaluationInfo.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<!-- -->
<template>
  <div>
    <e-table-list-merge
      :table-data="tableData"
      :table-label="tableLabel"
      :right-span-method="handleTableSpan"
    >
      <template #applyAmount="slot">
        <div>
          {{ slot.scope.row.applyAmount | thousandsSeparator }}
        </div>
      </template>
      <template #productRemarkList="slot">
        <div>
          <el-select
            v-model="slot.scope.row.productRemark"
            placeholder="请选择备注"
            @change="getEvaluationInfoRemark"
          >
            <el-option
              v-for="productRemark in slot.scope.row.productRemarkList"
              :key="productRemark"
              :label="productRemark"
              :value="productRemark"
            >
            </el-option>
          </el-select>
        </div>
      </template>
      <template #creditStartDate="slot">
        <span>{{ creditStartDate }}</span
        >至 <span>{{ creditDeadline }}</span>
      </template>
      <template #operation="slot">
        <eui-btn
          font-size="12px"
          type="link"
          @click="deleteLineInfo(slot.scope.row)"
        >
          删除
        </eui-btn>
      </template>
      <template #sceneReportAttachPath="slot">
        <eui-btn
          v-if="slot.scope.row.subStatus == 5"
          font-size="12px"
          type="link"
          @click="showEvaluationReport(slot.scope.row, 'sceneReport')"
        >
          现场审查报告
        </eui-btn>
      </template>
      <template #testReportAttachPath="slot">
        <eui-btn
          v-if="slot.scope.row.subStatus == 5"
          font-size="12px"
          type="link"
          @click="showEvaluationReport(slot.scope.row, 'testReport')"
        >
          检测报告
        </eui-btn>
      </template>
      <template #subStatusDesc="slot">
        <eui-btn
          v-if="slot.scope.row.subStatus == 5"
          font-size="12px"
          type="link"
        >
          评价证书
        </eui-btn>
      </template>
    </e-table-list-merge>
    <!-- <el-table
      row-key="id"
      :data="tableData"
      border
      style="width: 100%; margin-top: 20px"
      default-expand-all
      :tree-props="{ children: 'childrens', hasChildren: 'hasChildren' }"
    >
      <el-table-column prop="evaluationCode" label="评价编码" width="180">
      </el-table-column>
      <el-table-column prop="evaluateMethodName" label="产品评价办法">
      </el-table-column>
      <el-table-column prop="className" label="产品类目"> </el-table-column>
      <el-table-column prop="range" label="覆盖范围"> </el-table-column>
      <el-table-column prop="productName" label="产品名称"> </el-table-column>
      <el-table-column prop="applyAmount" label="检测费"> </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <div>
            <eui-btn type="link">删除</eui-btn>
          </div>
        </template>
      </el-table-column>
    </el-table> -->
    <div class="last-table-row">
      <span
        >现场审查费:￥{{
          evaluationInfo.siteReviewFee != 0
            ? evaluationInfo.siteReviewFee
            : 0 | thousandsSeparator
        }}(首次申请时收取, 三年内无需再次支付)</span
      >
      <span>产品检测费:￥{{ evaluationInfo.amount | thousandsSeparator }}</span>
      <span
        >总评价费:<i
          >￥{{ evaluationInfo.totalAmount | thousandsSeparator }}</i
        ></span
      >
    </div>
    <div v-if="isShowConsult" class="contact-wrap">
      <span
        >业务咨询人：{{ businessConsultTableData[0].businessConsultName }}</span
      >
      <span>{{ businessConsultTableData[0].businessConsultTel }}</span>
      <span>{{ businessConsultTableData[0].businessConsultEmail }}</span>
      <span class="table-handle-btn" @click="showBusinessConsultDialog"
        >查看更多业务咨询人></span
      >
    </div>
    <eDialog
      dialog-title="查看业务咨询人"
      :center-dialog-visible="businessConsultVisible"
      :popup-width="'580px'"
      @resetPopupData="setResetPopupData"
      @submitPopupData="setSubmitPopupData"
    >
      <eTableList
        :loading="false"
        :table-data="businessConsultTableData"
        :table-label="businessConsultTableLabel"
        :index-show="true"
      ></eTableList>
    </eDialog>
    <eDialog
      dialog-title="提示"
      :center-dialog-visible="deleteEvalutionProductVisible"
      @resetPopupData="setDeleteEvalutionProductPopupData"
      @submitPopupData="setDeleteEvalutionProductSubmitPopupData"
    >
      <span>确定删除?</span>
    </eDialog>
    <eDialog
      dialog-title="评价"
      :center-dialog-visible="rateVisible"
      :popup-width="'420px'"
      @resetPopupData="setRateResetPopupData"
      @submitPopupData="setRateSubmitPopupData"
    >
      <el-form ref="form" :model="form" label-width="180px" :rules="rateRules">
        <el-form-item label="评价过程严谨性:" prop="processRigorScore">
          <el-rate v-model="form.processRigorScore" :colors="colors"> </el-rate>
        </el-form-item>
        <el-form-item label="评价结果公正性:" prop="resultFairnessScore">
          <el-rate v-model="form.resultFairnessScore" :colors="colors">
          </el-rate>
        </el-form-item>
        <el-form-item label="评价人员工作作风:" prop="workStyleScore">
          <el-rate v-model="form.workStyleScore" :colors="colors"> </el-rate>
        </el-form-item>
        <el-form-item label="评价人员廉洁从业情况:" prop="cleanEmploymentScore">
          <el-rate v-model="form.cleanEmploymentScore" :colors="colors">
          </el-rate>
        </el-form-item>

        <el-form-item label-width="0">
          <p>对易派客产品质量评价工作有何建议和意见？</p>
          <el-input
            v-model="form.suggestions"
            type="textarea"
            placeholder="请输入意见和建议"
            maxlength="100"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
    </eDialog>
  </div>
</template>

<script>
import eDialog from '@/components/common/e-dialog.vue';
import utils from '@/modules/projectA/utils/utils';
import eTableListMerge from '../../../../components/common/e-table-list-merge.vue';
import api from '../../../../api/evaluation/index';
import eTableList from '../../../../components/common/e-table-list.vue';

export default {
  components: { eTableListMerge, eDialog, eTableList },
  props: {
    applyId: {
      type: Number,
    },
    applyStatus: {
      type: Number,
    },
    flag: {
      type: String,
      default: '',
    },
  },
  data() {
    const validateRate = (rule, value, callback) => {
      if (value === 0) {
        callback(new Error('请选择评分'));
      } else {
        callback();
      }
    };
    return {
      tableData: [],
      tableLabel: [
        { label: '评价编码', param: 'evaluationCode', align: 'center' },
        { label: '产品评价办法', param: 'evaluateMethodName', align: 'center' },
        { label: '产品类目', param: 'className', align: 'center' },
        { label: '覆盖范围', param: 'level', align: 'center' },
        { label: '产品名称', param: 'productName', align: 'center' },
        { label: '初评检测费', slot: 'applyAmount', align: 'right' },
        { label: '备注', slot: 'productRemarkList', align: 'center' },
        { label: '操作', slot: 'operation', align: 'center' },
        { label: '评价状态', param: 'subStatusDesc', align: 'center' },
        { label: '现场审查', param: 'fieldReviewDesc', align: 'center' },
        { label: '有效期', slot: 'creditStartDate', align: 'center' },
        { label: '评级', param: 'grade', align: 'center' },
        {
          label: '现场审查报告',
          slot: 'sceneReportAttachPath',
          align: 'center',
        },
        { label: '检测报告', slot: 'testReportAttachPath', align: 'center' },
        { label: '评价证书', slot: 'subStatusDesc', align: 'center' },
        { label: '评价报告', param: 'subStatusDesc', align: 'center' },
      ],
      spanArr: [],
      position: 0,
      businessConsultVisible: false,
      businessConsultTableData: [],
      businessConsultTableLabel: [
        { label: '业务咨询人', param: 'businessConsultName', align: 'center' },
        { label: '电话', param: 'businessConsultTel', align: 'center' },
        { label: '邮箱', param: 'businessConsultEmail', align: 'center' },
      ],
      evaluationInfo: {},
      deleteEvalutionProductVisible: false,
      productInfo: {},
      isShowRemark: false, // 是否展示备注
      form: {
        processRigorScore: 0,
        resultFairnessScore: 0,
        workStyleScore: 0,
        cleanEmploymentScore: 0,
        suggestions: null,
      },
      colors: ['#55B3CF', '#55B3CF', '#55B3CF'],
      rateVisible: false,
      rateRules: {
        processRigorScore: [
          { required: true, validator: validateRate, trigger: 'change' },
        ],
        resultFairnessScore: [
          { required: true, validator: validateRate, trigger: 'change' },
        ],
        workStyleScore: [
          { required: true, validator: validateRate, trigger: 'change' },
        ],
        cleanEmploymentScore: [
          { required: true, validator: validateRate, trigger: 'change' },
        ],
      },
      productInfoInLine: {}, // 单元分行信息
    };
  },

  computed: {
    isShowConsult() {
      return this.businessConsultTableData.length > 0;
    },
  },

  async created() {
    await this.getEvaluationInfo(this.applyId);
    await this.showRemark();
    if (this.flag) {
      this.tableLabel = [
        { label: '评价编码', param: 'evaluationCode', align: 'center' },
        { label: '产品评价办法', param: 'evaluateMethodName', align: 'center' },
        { label: '产品类目', param: 'className', align: 'center' },
        { label: '覆盖范围', param: 'level', align: 'center' },
        { label: '产品名称', param: 'productName', align: 'center' },
        { label: '初评检测费', slot: 'applyAmount', align: 'right' },
      ];
    }
  },
  mounted() {},
  methods: {
    showRemark() {
      if (this.isShowRemark === false) {
        this.tableLabel.splice(6, 1);
      }
      if (
        this.applyStatus === 200 ||
        this.applyStatus === 219 ||
        this.applyStatus === 101
      ) {
        this.tableLabel.splice(7);
      }
      if (
        this.applyStatus === 207 ||
        this.applyStatus === 206 ||
        this.applyStatus === 205 ||
        this.applyStatus === 217 ||
        this.applyStatus === 218 ||
        this.applyStatus === 208 ||
        this.applyStatus === 210 ||
        this.applyStatus === 213 ||
        this.applyStatus === 214
      ) {
        this.tableLabel.splice(6);
      }

      if (
        this.applyStatus === 211 ||
        this.applyStatus === 212 ||
        this.applyStatus === 216
      ) {
        this.tableLabel.splice(6, 1);
      }
    },

    async getEvaluationInfo(applyId) {
      const res = await api.getEvaluationApplyDetail({ applyId });
      if (res.code === '200') {
        const { evaluationApplyItemPriceVOList } = res.data;
        // for (let i = 0; i < evaluationApplyItemVOList.length; i++) {
        //   evaluationApplyItemVOList[i].childrens = this.treeToList(
        //     evaluationApplyItemVOList[i].evaluationApplyItemPriceVOList
        //   );
        // }
        this.evaluationInfo = res.data;
        this.businessConsultTableData =
          this.evaluationInfo.evaluationBusinessConsultVOList;
        this.tableData = evaluationApplyItemPriceVOList;
        console.log(this.businessConsultTableData);
        this.isShowRemark = this.evaluationInfo.productRemarkFlag;
        this.spanArr = [];
        this.rowspan();
      }
    },

    // 先序遍历树结构
    treeToList(tree, result = [], level = 0) {
      tree.forEach((node) => {
        result.push(node);
        node.level = level + 1;
        node.children && this.treeToList(node.children, result, level + 1);
      });
      return result;
    },
    handleTableSpan({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        const _row = this.spanArr[rowIndex]; // spanArr为控制合并几行的数组eg:[4, 0, 0, 0, 4, 0, 0, 0, 2, 0]
        const _col = _row > 0 ? 1 : 0; // 合并的行数大于0那就只有一列，小于0就列数为0,相当于没了
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      if (columnIndex === 1) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      if (columnIndex === 2) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
    },
    rowspan() {
      this.tableData.forEach((item, index) => {
        if (index === 0) {
          // 首次遍历获取得到的数据，将第一行数据控制合并行数的数组push(1)，表示合并一行
          this.spanArr.push(1);
          this.position = 0;
        } else if (
          this.tableData[index].evaluationCode ===
          this.tableData[index - 1].evaluationCode
        ) {
          this.spanArr[this.position] += 1; // 只要sDtsend(发放月份)字段相等，spanArr的第index个元素就加1表示合并一行
          this.spanArr.push(0); // 被合并的行要push(0)表示没了被合并了
        } else {
          // 直到某字段不等时，改变position值
          this.spanArr.push(1); // push(1)是因为行不合并也是从1行开始
          this.position = index; // 等于index表示从不等的那一行序号开始从1往上加
        }
      });
      console.log(this.spanArr);
    },
    deleteLineInfo(row) {
      console.log(row);
      const { applyId, evaluationItemId, id } = row;
      this.productInfo = { applyId, evaluationItemId, id };
      this.deleteEvalutionProductVisible = true;
    },
    setDeleteEvalutionProductPopupData() {
      this.productInfo = {};
      this.deleteEvalutionProductVisible = false;
    },
    async setDeleteEvalutionProductSubmitPopupData() {
      const params = this.productInfo;
      const res = await api.deleteEvaluationApplyItemPrice([params]);
      if (res.code === '200') {
        this.deleteEvalutionProductVisible = false;
        await this.getEvaluationInfo(this.applyId);
        if (this.tableData.length === 0) {
          this.$router.push({ path: '/ES/ESapply' });
        }
      }
    },

    setResetPopupData() {
      this.businessConsultVisible = false;
    },
    setSubmitPopupData() {
      this.businessConsultVisible = false;
    },
    showBusinessConsultDialog() {
      this.businessConsultTableData =
        this.evaluationInfo.evaluationBusinessConsultVOList;
      this.businessConsultVisible = true;
    },
    // 获取产品评价信息备注
    getEvaluationInfoRemark() {
      this.$emit('handleRemark', this.tableData);
    },
    setRateResetPopupData() {},
    setRateSubmitPopupData() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          // alert('submit!');
          console.log(this.form);
          this.form.evaluateItemPriceId =
            this.productInfoInLine.evaluateItemPriceId;
          this.form.evaluationItemId = this.productInfoInLine.evaluationItemId;
          const res = await api.addApplyItemPriceRate(this.form);
          if (res.code === '200') {
            this.rateVisible = false;
          }
          this.rateVisible = false;
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    async showEvaluationReport(row, type) {
      if (row.rateFlag) {
        this.productInfoInLine = row;
        this.rateVisible = true;
      } else {
        let params = {
          attachmentName: '',
          attachmentUrl: '',
        };
        if (type === 'sceneReport') {
          params = {
            attachmentName: row.sceneReportAttachName,
            attachmentUrl: sceneReportAttachPath,
          };
        } else {
          params = {
            attachmentName: row.testReportAttachName,
            attachmentUrl: testReportAttachPath,
          };
        }
        const res = await api.downLoadEvaluationFile(params);
        if (res.type == 'application/json') {
          utils.fileExportResponseError(res);
        } else {
          const reportName =
            type === 'sceneReport'
              ? row.sceneReportAttachName
              : row.testReportAttachName;
          utils.downFile(res, reportName, '.pdf');
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.contact-wrap {
  font-size: 0;
  margin-top: 20px;
  span:not(:last-child) {
    color: #333;
  }
  span {
    font-size: 14px;
    line-height: 14px;
    margin-bottom: 12px;
    margin-right: 20px;
  }
}
.last-table-row {
  display: flex;
  flex-flow: row;
  align-items: center;
  justify-content: flex-end;
  color: #333;
  font-size: 12px;
  border-left: 1px solid #ebeef5;
  border-bottom: 1px solid #ebeef5;
  border-right: 1px solid #ebeef5;
  height: 50px;
  span {
    margin-right: 10px;
    i {
      font-style: normal;
      color: #e50113;
      font-size: 12px;
    }
  }
}
</style>
